import { render, staticRenderFns } from "./membershipImpower.vue?vue&type=template&id=bd70d440&scoped=true"
import script from "./membershipImpower.vue?vue&type=script&lang=js"
export * from "./membershipImpower.vue?vue&type=script&lang=js"
import style0 from "./membershipImpower.vue?vue&type=style&index=0&id=bd70d440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd70d440",
  null
  
)

export default component.exports